"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSnakeKeys = exports.toCamelcaseKeys = void 0;
/* eslint-disable @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment */
var lodash_1 = __importDefault(require("lodash"));
var convertCaseKeys = function (input, fun) {
    if (typeof input !== 'object' ||
        lodash_1.default.isNil(input)) {
        return input;
    }
    if (Array.isArray(input)) {
        return lodash_1.default.map(input, function (value) {
            return convertCaseKeys(value, fun);
        });
    }
    return (0, lodash_1.default)({}).tap(function (out) {
        Object.keys(input).forEach(function (key) {
            if (lodash_1.default.isNil(key)) {
                return;
            }
            var camelKey = fun(key);
            // @ts-ignore
            out[camelKey] = convertCaseKeys(input[key], fun);
        });
    }).value();
};
var toCamelcaseKeys = function (input) {
    return convertCaseKeys(input, lodash_1.default.camelCase);
};
exports.toCamelcaseKeys = toCamelcaseKeys;
var toSnakeKeys = function (input) {
    return convertCaseKeys(input, lodash_1.default.snakeCase);
};
exports.toSnakeKeys = toSnakeKeys;
